(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coming-soon"] && !Shopify.designMode) return;
  try {
    
  // Handle video pause on end for uploaded videos
  const video = document.querySelector('.coming-soon-video')
  if (video) {
    video.addEventListener('ended', function () {
      this.pause()
    })
  }

  // Handle YouTube video pause on end
  const youtubeIframe = document.getElementById('youtube-video')
  if (youtubeIframe) {
    let ytPlayer
    function onYouTubeIframeAPIReady() {
      ytPlayer = new YT.Player('youtube-video', {
        events: {
          onStateChange: function (event) {
            if (event.data === YT.PlayerState.ENDED) {
              ytPlayer.pauseVideo()
            }
          },
        },
      })
    }

    // Load YouTube API if not already loaded
    if (typeof YT === 'undefined') {
      const tag = document.createElement('script')
      tag.src = 'https://www.youtube.com/iframe_api'
      const firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
      window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady
    } else {
      onYouTubeIframeAPIReady()
    }
  }

  // Handle Vimeo video pause on end
  const vimeoIframe = document.getElementById('vimeo-video')
  if (vimeoIframe) {
    let vimeoPlayer
    if (typeof Vimeo !== 'undefined') {
      vimeoPlayer = new Vimeo.Player(vimeoIframe)
      vimeoPlayer.on('ended', function () {
        vimeoPlayer.pause()
      })
    } else {
      // Load Vimeo API if not already loaded
      const tag = document.createElement('script')
      tag.src = 'https://player.vimeo.com/api/player.js'
      tag.onload = function () {
        vimeoPlayer = new Vimeo.Player(vimeoIframe)
        vimeoPlayer.on('ended', function () {
          vimeoPlayer.pause()
        })
      }
      document.head.appendChild(tag)
    }
  }

  } catch(e) { console.error(e); }
})();
})();
